import { render, staticRenderFns } from "./pdfViwer.vue?vue&type=template&id=004cd30e&"
import script from "./pdfViwer.vue?vue&type=script&lang=js&"
export * from "./pdfViwer.vue?vue&type=script&lang=js&"
import style0 from "./pdfViwer.vue?vue&type=style&index=0&id=004cd30e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports